/*
 * Takes in an integer and returns it in time format without it having to be a DATE
 * convertNumberToTimeFormat(5) => 05
 * convertNumberToTimeFormat(5.5) => 05
 * convertNumberToTimeFormat(12) => 12
 */

export const convertNumberToMinimumTwoDigits = (number) => {
  const newInt = Number.parseInt(number, 10);
  if (newInt < 10 && newInt > -1) {
    return `0${newInt}`;
  }

  return newInt;
};

export const getTimeDisplay = (time) => {
  if (!time) return '00:00';

  const minutes = convertNumberToMinimumTwoDigits(Math.floor(time / 60));
  const seconds = convertNumberToMinimumTwoDigits(time % 60);

  return `${minutes}:${seconds}`;
};
